var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIconOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shipment_Details_Documents",
    clipPath: "url(#clip0_213_6335)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-494 -443)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3898",
    clipPath: "url(#clip1_213_6335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3796"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1655",
    x: -395,
    y: 1,
    width: 1391,
    height: 48,
    rx: 8,
    fill: "#F5F7FB"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1672",
    x: -494,
    y: -443,
    width: 1512,
    height: 982,
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 48",
    filter: "url(#filter0_dd_213_6335)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -33,
    y: -126,
    width: 591,
    height: 348,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_page_black_24dp 3",
    clipPath: "url(#clip2_213_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.17 2L14 6.83V18H2V2H9.17ZM10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V6L10 0ZM8 12C9.1 12 10 11.1 10 10C10 8.9 9.1 8 8 8C6.9 8 6 8.9 6 10C6 11.1 6.9 12 8 12ZM12 15.43C12 14.62 11.52 13.9 10.78 13.58C9.93 13.21 8.99 13 8 13C7.01 13 6.07 13.21 5.22 13.58C4.48 13.9 4 14.62 4 15.43V16H12V15.43Z",
    fill: "#0062FF"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_213_6335",
    x: -45,
    y: -126,
    width: 615,
    height: 372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_213_6335"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_6335"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_213_6335"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_213_6335",
    result: "effect2_dropShadow_213_6335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_213_6335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white",
    transform: "translate(-494 -443)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_213_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1391,
    height: 527,
    fill: "white",
    transform: "translate(-396 -63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_213_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-4 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconOutline);
export default __webpack_public_path__ + "static/media/file-icon-outline.efd514bcfe70b706ef020d2d5f3279b2.svg";
export { ForwardRef as ReactComponent };